<template>
  <div
    id="ag-table"
    class="dataTables_wrapper dt-bootstrap4 no-footer"
    :class="`${options.id ? options.id + '-wrapper' : ''}`"
  >
    <component
      v-if="$parent.$parent.filterComponent"
      :is="$parent.$parent.filterComponent"
      :parent="$parent.$parent"
    ></component>
    <component
      v-if="$parent.$parent.breadcrumbComponent"
      :is="$parent.$parent.breadcrumbComponent"
      :parent="$parent.$parent"
    ></component>
    <div
      class="table-responsive"
      v-if="!options.isLoading && options.rows.length > 0"
    >
      <table
        :class="['table', 'table-hover', { 'ag-zebra': options.zebra, 'ag-separate-borders': options.separateBorders === true }]"
        :id="options.id"
        :key="setting.compKey"
      >
        <!-- <div class="row"></div> -->
        <!-- <div v-if="options.isLoading" class="loading-mask">
          <div class="loading-content">
            <span style="color: white">Loading...</span>
          </div>
        </div> -->
        <thead>
          <tr>
            <th v-if="options.hasCheckbox" class="checkbox-th">
              <div style="padding-left: 10px">
                <input
                  type="checkbox"
                  v-model="setting.isCheckAll"
                  ref="isCheckAll"
                />
              </div>
            </th>
            <th
              v-for="(col, index) in options.columns.filter(
                (c) => !(c.hidden && c.hidden($parent, c))
              )"
              :key="index"
              :style="{ width: col.width ? col.width : 'auto' }"
            >
              <div
                :class="{
                  sortable: col.sortable,
                  both: col.sortable,
                  'col-asc':
                    options.sortable.order == col.field &&
                    options.sortable.sort == 'asc',
                  'col-desc':
                    options.sortable.order == col.field &&
                    options.sortable.sort == 'desc',
                }"
                @click="col.sortable ? doSort(col.field) : false"
                :style="col.style"
              >
                <span v-if="!col.labelTooltip">{{ t(col.label) }}</span>
                <div class="ag-tooltip" v-if="col.labelTooltip">
                  {{ t(col.label) }} 
                  <div class="bottom">
                    {{ t(col.labelTooltip) }}
                    <i></i>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody v-if="options.isLoading">
          <tr>
            <td colspan="100%" style="padding: 0">
              <ag-loading />
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="options.rows.length > 0">
          <tr
            v-for="(row, i) in options.rows"
            :key="i"
            :class="{
              'deleted-row': options.hasShowDeleted && row && row.isDeleted,
              'row-clickable': options.editOnRowClick === true,
              'disabled-row': row && row.enabled === false,
            }"
          >
            <td v-if="options.hasCheckbox">
              <div class="row-checkbox">
                <input
                  type="checkbox"
                  :ref="
                    (el) => {
                      rowCheckbox[i] = el;
                    }
                  "
                  :value="row[setting.keyColumn]"
                  v-model="row.checked"
                  @click="checked"
                />
              </div>
            </td>
            <td
              v-for="(col, j) in options.columns.filter(
                (c) => !(c.hidden && c.hidden($parent, c, row))
              )"
              :key="j"
              @click="onCellClick(col, row, $event)"
              :style="col.style"
            >
              <div v-if="exportStatus">
                <div :class="['d-flex', col.justify || '']">
                  <component
                    v-for="(component, key) in col.components"
                    :is="component.component"
                    :options="component"
                    :key="key"
                    :data="row"
                    @edit="$emit('edit',row)"
                    @deleteClick="$emit('deleteClick',$event)"
                    @copyClick="$emit('copyClick',$event)"
                    >
                  ></component>
                </div>
                <div
                  v-show="
                    (col.components &&
                      col.components.length &&
                      col.components.findIndex(
                        (i) => i.component === 'rowRouter'
                      ) === -1) ||
                    !col.components
                  "
                >
                  <div v-if="col.display" v-html="col.display(row, t)"></div>
                  <div
                    v-else-if="col.field == 'filterJsonData'"
                    v-html="row.filterJsonDataTemplate"
                  ></div>
                  <span v-else>
                    <span v-if="col.format && col.format === 'number'">{{
                      row[col.field]
                        ? $filters.formatNumber(row[col.field])
                        : row[col.field]
                    }}</span>
                    <span v-else>
                      {{ row[col.field] }}
                    </span>
                  </span>
                </div>
              </div>
              <div v-if="!exportStatus">
                <div :class="['d-flex', col.justify || '']">
                  <component
                    v-for="(component, key) in col.components"
                    :is="component.component"
                    :options="component"
                    :key="key"
                    :data="row"
                    @edit="$emit('edit',row)"
                    @deleteClick="$emit('deleteClick',$event)"
                    @copyClick="$emit('copyClick',$event)"
                  ></component>
                </div>
                <div
                  v-show="
                    (col.components &&
                      col.components.length &&
                      col.components.findIndex(
                        (i) => i.component === 'rowRouter'
                      ) === -1) ||
                    !col.components
                  "
                >
                  <div v-if="col.display && col.field !== 'folderMapId'" v-html="col.display(row, t)"></div>
                  <div
                    v-else-if="col.field == 'filterJsonData'"
                    v-html="row.filterJsonDataTemplate"
                  ></div>
                  <div
                    v-else-if="col.tooltip"
                  >
                    <tooltip
                      :text="row.description"
                      :placement="typeof col.tooltip === 'string' ? col.tooltip : 'top'"
                    >
                      
                      <i
                        class="ag-icon ag-icon_table_info small info-icon" />
                    </tooltip>
                    <span v-if="col.truncate && col.truncate.tableShow" v-html="col.truncate.tableShow(row)"></span>
                    <span v-else style="color: #01172F; font-weight: bold; margin-left: 5px;">{{ row[col.field] }}</span>
                  </div>
                  <div
                    v-else-if="col.field === 'folderMapId'"
                  >                    
                    <div class="d-inline-flex align-items-center">
                      <span v-html="col.display(row, t)"></span>
                      <tooltip
                        v-if="row.__showReadOnlyInfo === true"
                        :text="$t('fileAccessReadOnlyTooltip')"
                        placement="top"
                      >
                        <i class="ag-icon ag-icon_table_info small info-icon" />
                      </tooltip>
                    </div>
                  </div>
                  <span v-else>
                    <span v-if="!col.components || col.components.length === 0">
                      
                      <span v-if="col.changeScope">
                        <a href="#" @click="changeScope(row)">{{
                          row[col.field]
                        }}</a>
                      </span>
                      <span v-else>
                        <ag-truncate
                          v-if="col.truncate"
                          :text="row[col.field]"
                          :data="row"
                          :options="col.truncate"
                        >
                        </ag-truncate>
                        <span v-else>{{ row[col.field] }}</span>
                        <ag-copy-paste
                          v-if="col.copyPaste"
                          :text="row[col.field]"
                        ></ag-copy-paste>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="row ag-table-no-data"
      v-if="!options.isLoading && options.rows.length == 0"
    >
      <div class="col-sm-12 text-center" v-if="options.message">
        {{ options.message }}
      </div>
      <div class="col-sm-12 text-center" v-else>
        {{ messages.noDataAvailable }}
      </div>
    </div>
    <div
      class="dataTables_bottom d-flex align-items-center justify-content-end"
      v-if="(!options.isLoading && options.rows.length > 0 && options.showPagination !== false) || options.message"
    >
      <div class="mr-2" role="status" aria-live="polite">
        {{
          messages.pagingInfo.format(
            setting.offset,
            setting.limit,
            options.total >= 0 ? options.total : 0
          )
        }}
      </div>
      <div class="mr-2">
        <span>{{ messages.pageSizeChangeLabel }}</span>
        <select v-model="options.pageSize">
          <option :value="5">5</option>
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
        </select>
      </div>
      <div
        class="dataTables_paginate paging_simple_numbers"
        id="dataTables-example_paginate"
      >
        <ul class="pagination m-0">
          <li class="page-item" :class="{ disabled: options.page <= 1 }">
            <a
              class="page-link"
              href="javascript:void(0)"
              aria-label="Previous"
              @click="options.page = 1"
            >
              <span aria-hidden="true">&laquo;</span>
              <span class="sr-only">First</span>
            </a>
          </li>
          <li class="page-item" :class="{ disabled: options.page <= 1 }">
            <a
              class="page-link"
              href="javascript:void(0)"
              aria-label="Previous"
              @click="prevPage"
            >
              <span aria-hidden="true">&lt;</span>
              <span class="sr-only">Prev</span>
            </a>
          </li>
          <li
            class="page-item"
            v-for="n in setting.pagging"
            :key="n"
            :class="{ 'disabled bolder active': options.page == n }"
          >
            <a
              class="page-link"
              href="javascript:void(0)"
              @click="movePage(n)"
              >{{ n }}</a
            >
          </li>
          <li
            class="page-item"
            :class="{ disabled: setting.page >= setting.maxPage }"
          >
            <a
              class="page-link"
              href="javascript:void(0)"
              aria-label="Next"
              @click="nextPage"
            >
              <span aria-hidden="true">&gt;</span>
              <span class="sr-only">Next</span>
            </a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: setting.page >= setting.maxPage }"
          >
            <a
              class="page-link"
              href="javascript:void(0)"
              aria-label="Next"
              @click="options.page = setting.maxPage"
            >
              <span aria-hidden="true">&raquo;</span>
              <span class="sr-only">{{$t("last")}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div v-else-if="options.isLoading">
      <ag-loading />
    </div>
    <iframe
      :src="agmsUrlForCompany"
      @load="onLoadIframe"
      frameborder="0"
      width="0px"
      height="0px"
      v-if="agmsUrlForCompany"
    ></iframe>
  </div>
</template>

<script>
String.prototype.format = function () {
  var args = arguments;
  return this.replace(/{([0-9]*)}/g, function (match, number) {
    return typeof args[number] != "undefined" ? args[number] : match;
  });
};

import {
  defineComponent,
  ref,
  reactive,
  computed,
  watch,
  onBeforeUpdate,
  nextTick,
} from "vue";
import { useI18n } from "vue-i18n";
import tableOtpComponent from "./components/otp";
import tableDeleteComponent from "./components/delete";
import tableNextPageComponent from "./components/nextPage";
import tableEditComponent from "./components/edit";
import appGroupTableEditComponent from "./components/appGroupTableEdit";
import appGroupDeleteComponent from "./components/appGroupDelete.vue";
import copyAction from "./components/copyAction.vue";
import tableResetPassComponent from "./components/resetPass";
import tableReloadComponent from "./components/reload";
import tableStatusChanger from "./components/status";
import tableAction from "./components/action.vue";
import tableRowLinks from "./components/rowLinks.vue";
import tableTrustedListStatus from "./components/trustedListStatus.vue";
import tableEventTypeSelector from "./components/EventTypeSelector.vue";
import tableExpandComponent from "./components/ExpandRow";
import tableShowComponent from "./components/ShowRow";
import ThreatPath from "./components/ThreatPath";
import tableModalComponent from "./components/ModalRow";
import tableDateFormatter from "./components/dateFormatter.vue";
import tableJsonViewer from "./components/jsonViewer.vue";
import tableToggle from "./components/toggle.vue";
import runSavedFilter from "./components/runSavedFilter.vue";
import rowRouter from "./components/rowRouter.vue";
import userAsset from "./components/userAsset.vue";
import rowCustomRouter from "./components/rowCustomRouter.vue";
import AgLoading from "@/components/ag-loading/index.vue";
import AgTruncate from "@/components/ag-truncate/index.vue";
import AgCopyPaste from "@/components/ag-copy-paste/index.vue";
import Tooltip from "@/components/ag-edit-panel/forms/components/tooltip.vue";
import tableLoadComponent from "./components/LoadRow.vue";
import { mapActions, mapGetters } from "vuex";
import { AuthActionTypes } from "@/store/modules/auth/action-types";
import { Roles } from "@/helpers/enums/Roles";
import { useStore } from "@/store";
const store = useStore();

export default defineComponent({
  name: "my-table",
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          columns: [],
          rows: 0,
          sortable: {
            order: "firstName",
            sort: "asc",
          },
          total: 0,
          page: 1,
          pageSize: 5,
          isLoading: true,
          showPagination:true,
          fetchTable: () => {
            console.log("LOAD");
          },
        };
      },
    },
    /*isLoading: {
      type: Boolean,
      require: true,
      default: true,
    },*/
    isReSearch: {
      type: Boolean,
      require: true,
    },
    title: {
      type: String,
      default: "",
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    sortable: {
      type: Object,
      default: () => {
        return {
          order: "id",
          sort: "asc",
        };
      },
    },
    messages: {
      type: Object,
      default: () => {
        return {
          pagingInfo: "{2} Results",
          pageSizeChangeLabel: "",
          gotoPageLabel: "",
          noDataAvailable: "No Data",
        };
      },
    },
  },
  setup(props, { emit }) {
    // 組件用內部設定值
    const setting = reactive({
      // 是否全選
      isCheckAll: false,
      // KEY欄位名稱
      keyColumn: computed(() => {
        let key = "";
        props.options.columns.forEach((col) => {
          if (col.isKey) {
            key = col.field;
          }
        });
        return key;
      }),
      // 當前頁數
      page: props.options.page,
      // 每頁顯示筆數
      pageSize: props.options.pageSize,
      // 最大頁數
      maxPage: computed(() => {
        const maxAllowedTotal = 10000;
        
        if (props.options.total > maxAllowedTotal) {
          props.options.total = maxAllowedTotal;
        }

        if (props.options.total <= 0) {
          return 0;
        }
        
        let maxPage = Math.floor(props.options.total / props.options.pageSize);
        let mod = props.options.total % props.options.pageSize;
        if (mod > 0) {
          maxPage++;
        }
        return maxPage;
      }),
      // 該頁數起始值
      offset: computed(() => {
        return (props.options.page - 1) * props.options.pageSize + 1;
      }),
      // 該頁數最大值
      limit: computed(() => {
        let limit = props.options.page * props.options.pageSize;
        return props.options.total >= limit ? limit : props.options.total;
      }),
      // 換頁陣列
      pagging: computed(() => {
        let startPage =
          props.options.page - 2 <= 0 ? 1 : props.options.page - 2;
        if (props.options.maxPage - props.options.page <= 2) {
          startPage = setting.maxPage - 4;
        }
        startPage = startPage <= 0 ? 1 : startPage;
        let pages = [];
        for (let i = startPage; i <= setting.maxPage; i++) {
          if (pages.length < 5) {
            pages.push(i);
          }
        }
        return pages;
      }),
      compKey: 0,
      jsSort: false,
    });
    ////////////////////////////
    //
    //  Checkbox 相關操作
    //
    // 定義Checkbox參照
    const rowCheckbox = ref([]);
    if (props.options.hasCheckbox) {
      /**
       * 重新渲染前執行
       */
      onBeforeUpdate(() => {
        // 每次更新前都把值全部清空
        rowCheckbox.value = [];
      });

      /**
       * 監聽全勾選Checkbox
       */
      watch(
        () => setting.isCheckAll,
        (state) => {
          let isChecked = [];
          rowCheckbox.value.forEach((val, index) => {
            if (val) {
              val.checked = state;
              props.options.rows[index].checked = state;
              if (val.checked == true) {
                isChecked.push(val.value);
              }
            }
          });
          // 回傳畫面上選上的資料
          emit("return-checked-rows", isChecked);
        }
      );
    }
    /**
     * Checkbox點擊事件
     */
    const checked = () => {
      let isChecked = [];
      rowCheckbox.value.forEach((val) => {
        if (val && val.checked == true) {
          isChecked.push(val.value);
        }
      });
      // 回傳畫面上選上的資料
      emit("return-checked-rows", isChecked);
    };

    /**
     * 清空畫面上所有選擇資料
     */
    // const clearChecked = () => {
    //   rowCheckbox.value.forEach((val) => {
    //     if (val && val.checked == true) {
    //       val.checked = false;
    //     }
    //   });
    //   // 回傳畫面上選上的資料
    //   emit("return-checked-rows", []);
    // };

    ////////////////////////////
    //
    //  排序·換頁等 相關操作
    //
    /**
     * 呼叫執行排序
     */
    const doSort = (order) => {
      props.options.sortable.sort == "asc"
        ? (props.options.sortable.sort = "desc")
        : (props.options.sortable.sort = "asc");
      props.options.sortable.order = order;

      const findRow = props.options.columns.find((i) => i.field === order);
      if (findRow && findRow.jsSort) {
        setting.jsSort = true;

        if (props.options.sortable.sort == "asc") {
          props.options.rows = props.options.rows.sort(
            (a, b) => {
              const aVal = a[order];
              const bVal = b[order];
              if (aVal == null && bVal == null) return 0;
              if (aVal == null) return 1;
              if (bVal == null) return -1;

              const isStr = (v) => typeof v === 'string' || v instanceof String;
              if (isStr(aVal) || isStr(bVal)) {
                const aStr = aVal.toString();
                const bStr = bVal.toString();
                return aStr.localeCompare(bStr);
              } else {
                const aNum = Number(aVal);
                const bNum = Number(bVal);
                return aNum - bNum;
              }
            }
          );
          ++setting.compKey;
        } else {
          props.options.rows = props.options.rows.sort(
            (a, b) => {
              const aVal = a[order];
              const bVal = b[order];
              if (aVal == null && bVal == null) return 0;
              if (aVal == null) return 1;
              if (bVal == null) return -1;

              const isStr = (v) => typeof v === 'string' || v instanceof String;
              if (isStr(aVal) || isStr(bVal)) {
                const aStr = aVal.toString();
                const bStr = bVal.toString();
                return bStr.localeCompare(aStr);
              } else {
                const aNum = Number(aVal);
                const bNum = Number(bVal);
                return bNum - aNum;
              }
            }
          );
          ++setting.compKey;
        }
        // if (props.options.sortable.sort == "asc") {
        //   props.options.rows = props.options.rows.sort(
        //     (a, b) => {
        //       if (typeof a[order] === 'string' || a[order] instanceof String) {
        //         return (a[order].toString()).localeCompare(b[order].toString())
        //       }else {
        //         return a[order] - b[order]
        //       }
        //     }
        //   );
        //   ++setting.compKey;
        // } 
        // else {
        //   props.options.rows = props.options.rows.sort(
        //     (a, b) => {
        //       if (typeof a[order] === 'string' || a[order] instanceof String) {
        //         return (b[order].toString()).localeCompare(a[order].toString())
        //       }else {
        //         return b[order] - a[order]
        //       }
        //     }
        //   );
        //   ++setting.compKey;
        // }
      } else {
        setting.jsSort = false;
      }
    };

    /**
     * 切換頁碼
     *
     * @param number page     新頁碼
     * @param number prevPage 現在頁碼
     */
    const changePage = (page, prevPage) => {
      setting.isCheckAll = false;
      let order = props.sortable.order;
      let sort = props.sortable.sort;
      let offset = (page - 1) * setting.pageSize;
      let limit = setting.pageSize;
      if (!props.isReSearch || page > 1 || page == prevPage) {
        // 非重新查詢發生的頁碼變動才執行呼叫查詢
        emit("do-search", offset, limit, order, sort);
      }
    };
    // 監聽頁碼切換
    watch(() => setting.page, changePage);

    /**
     * 切換顯示筆數
     */
    const changePageSize = () => {
      if (setting.page === 1) {
        // 沒自動觸發 changePage()，所以手動觸發
        changePage(setting.page, setting.page);
      } else {
        // 強制返回第一頁,並自動觸發 changePage()
        setting.page = 1;
        setting.isCheckAll = false;
      }
    };
    // 監聽顯示筆數切換
    watch(() => setting.pageSize, changePageSize);

    /**
     * 上一頁
     */
    const prevPage = () => {
      if (props.options.page == 1) {
        // 如果是第一頁，不予執行
        return false;
      }
      props.options.page--;
    };

    /**
     * 移動至指定頁數
     */
    const movePage = (page) => {
      props.options.page = page;
    };

    /**
     * 下一頁
     */
    const nextPage = () => {
      if (props.options.page >= setting.maxPage) {
        // 如果等於大於最大頁數，不與執行
        return false;
      }
      props.options.page++;
    };

    // 監聽資料變更
    watch(
      () => props.options.rows,
      () => {
        if (props.isReSearch) {
          setting.page = 1;
        }

        nextTick(function () {
          // 資料完成渲染後回傳私有元件
          let localElement = document.getElementsByClassName("is-rows-el");
          emit("is-finished", localElement);
        });
      }
    );

    const { t, locale } = useI18n();

    if (props.options.hasCheckbox) {
      // 需要 Checkbox 時
      return {
        setting,
        rowCheckbox,
        checked,
        doSort,
        prevPage,
        movePage,
        nextPage,
        t,
        locale,
      };
    } else {
      return {
        setting,
        doSort,
        prevPage,
        movePage,
        nextPage,
        t,
        locale,
      };
    }
  },
  watch: {
    "options.pageSize"(newVal) {
      this.options.page = 1;
      this.options.pageSize = newVal;
      this.options.fetchTable(this.options);
    },
    "options.page"() {
      this.options.fetchTable(this.options);
    },
    "options.sortable.order"() {
      if (!this.setting.jsSort) {
        this.options.fetchTable(this.options);
      }
    },
    "options.sortable.sort"() {
      if (!this.setting.jsSort) {
        this.options.fetchTable(this.options);
      }
    },
  },
  components: {
    tableOtpComponent,
    tableDeleteComponent,
    tableNextPageComponent,
    tableEditComponent,
    appGroupTableEditComponent,
    appGroupDeleteComponent,
    copyAction,
    tableResetPassComponent,
    tableReloadComponent,
    tableStatusChanger,
    tableAction,
    tableRowLinks,
    tableTrustedListStatus,
    tableEventTypeSelector,
    tableExpandComponent,
    tableShowComponent,
    tableDateFormatter,
    tableJsonViewer,
    tableModalComponent,
    tableToggle,
    runSavedFilter,
    rowRouter,
    userAsset,
    rowCustomRouter,
    tableLoadComponent,
    AgLoading,
    AgTruncate,
    Tooltip,
    AgCopyPaste,
    ThreatPath,
  },
  data() {
    return {
      agmsUrlForCompany: null,
    };
  },
  methods: {
    ...mapActions({
      setPartner: AuthActionTypes.SET_PARTNER,
      setUser: AuthActionTypes.SET_USER,
    }),
    onCellClick(col, row, evt) {
      if (typeof col?.onclick === 'function') {
        try { col.onclick(row, evt); } catch (e) { /* no-op */ }
        return;
      }
      const hasComponents = Array.isArray(col?.components) && col.components.length > 0;
      if (this.options?.editOnRowClick && !hasComponents) {
        const isAppManagement = this.$parent?.module?.component?.name === 'appManagementTable' || this.options?.name === 'appManagementTable'; 
        if (isAppManagement) { 
            const currentRouteName = this.$route?.name;
            const targetPath = currentRouteName === 'templateAppGroupManagement'
              ? '/administration/app-group-management/detail-role'
              : '/administration/app-group-management/detail';
            this.$router.push({ path: targetPath, query: { id: row?.id } }); } 
          else { 
            this.$emit('edit', row); 
          }
      }
    },
    changeScope(data) {
      const partner = data;
      partner.guid = data.id;
      partner.type = 0;
      localStorage.setItem("partner", JSON.stringify(partner));
      let tempUser = this.mainUser;
      const roleIndex = tempUser.findIndex((i) => i.type === "role");
      localStorage.setItem("scopeChange", true);
      localStorage.setItem("selectedRole", Roles.PartnerAdmin);
      localStorage.setItem("changingScope", true);
      if (roleIndex > -1) {
        tempUser[roleIndex].value = Roles.PartnerAdmin;
        this.setUser(tempUser);
        this.options.isLoading = true;
      }
      this.agmsUrlForCompany =
        process.env.VUE_APP_AGMS_URL +
        `/MultiTenant/ManageCompany/AGMSDashboard?partnerId=${partner.guid}`;
    },
    onLoadIframe() {
      const url = this.agmsUrlForCompany;
      this.agmsUrlForCompany = null;
      ++this.loadCount;
      this.agmsUrlForCompany = url;
      setTimeout(() => {
        location.href = "/dashboard/company-overview";
      }, 2000);
    },
  },
  computed: {
    ...mapGetters(["user", "mainUser", "partner", "loggedInUser"]),
    exportStatus() {
      return store.getters.exportStatus;
    },
  },
});
</script>

<style scoped>
.ag-table-no-data {
  padding: 32px;
}
.row-checkbox {
  display: inline !important;
  vertical-align: middle !important;
  padding-left: 10px !important;
}

.checkbox-th {
  width: 1%;
}

.both {
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC");
}

.bolder {
  font-weight: bolder;
}
.sortable {
  cursor: pointer;
  background-position: right;
  background-repeat: no-repeat;
  padding-right: 10px !important;
}

.col-asc {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZ0lEQVQ4y2NgGLKgquEuFxBPAGI2ahhWCsS/gDibUoO0gPgxEP8H4ttArEyuQYxAPBdqEAxPBImTY5gjEL9DM+wTENuQahAvEO9DMwiGdwAxOymGJQLxTyD+jgWDxCMZRsEoGAVoAADeemwtPcZI2wAAAABJRU5ErkJggg==);
  background-position-y: 1px;
}

.col-desc {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAZUlEQVQ4y2NgGAWjYBSggaqGu5FA/BOIv2PBIPFEUgxjB+IdQPwfC94HxLykus4GiD+hGfQOiB3J8SojEE9EM2wuSJzcsFMG4ttQgx4DsRalkZENxL+AuJQaMcsGxBOAmGvopk8AVz1sLZgg0bsAAAAASUVORK5CYII=);
  background-position-y: -3px;
}

.loading-mask {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.loading-content {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 93vh;
}

.loading-icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
}

th {
  text-align: inherit;
}

tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

tr.deleted-row {
  opacity: 0.5 !important;
}

tr.disabled-row {
  opacity: 0.5;
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}

.table-bordered thead td,
.table-bordered thead th {
  border-bottom-width: 2px;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}

.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}

.table td,
.table th {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
}

.table-border {
  border: 1px solid #dee2e6;
}


.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}

.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}

.page-item.active a {
  background: #4c8dbb;
  color: #fff !important;
}

.page-item a:focus,
.page-item a:hover {
  outline: none !important;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
#ag-table,
#ag-table .table-responsive {
  position: relative;
  z-index: 200;
}

.ag-zebra tbody tr:nth-child(odd) {
  background-color: #EFF1F9;
}

.ag-zebra tbody tr:nth-child(even) {
  background-color: #ffffff;
}

.ag-zebra.table-hover tbody tr:hover {
  background-color: #E5E8F8;
}

tr.row-clickable:hover {
  cursor: pointer;
}

.table.ag-separate-borders {
  border-collapse: separate !important;
  border-spacing: 0; 
}
.table.ag-separate-borders.table-bordered {
  border: 1px solid #D2D9E2;
}
.table.ag-separate-borders thead th {
  border-bottom: 1px solid #D2D9E2 !important;
}

.table.ag-separate-borders td,
.table.ag-separate-borders th {
  border-top: 1px solid #D2D9E2 !important;
  border-left: 1px solid #D2D9E2 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
}

.table.ag-separate-borders tr > th:last-child,
.table.ag-separate-borders tr > td:last-child {
  border-right: 1px solid #D2D9E2 !important;
}

.table.ag-separate-borders tbody tr:last-child > td,
.table.ag-separate-borders thead tr:last-child > th {
  border-bottom: 1px solid #D2D9E2 !important;
}
</style>
